<section>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h4 class="cctvmain_title">Bulk Upload DVR Details</h4>
            </div>

            <div class="cctvcouncelling__sec">
                <div class="councellist__flex">
                    <div class="file">
                        <div class="file-details">
                            <!-- <h3>Upload File</h3> -->
                            <form [formGroup]="fileUploadForm" (ngSubmit)="onFormSubmit()">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div>
                                            <h6 class="head-title margin-top-8 upload-text"><span>UPLOAD</span></h6>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 text-center custom-box">
                                        <div class="custom-file">
                                            <input type="file" class="custom-file-input" id="customFile" name="myfile"
                                                (change)="onFileSelect($event)" #UploadFileInput>
                                            <label class="custom-file-label" for="customFile">{{fileInputLabel ||
                                                'Choose File'}}</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2 text-center">
                                        <button class="btn btn-primary" type="submit"> Upload file</button>
                                    </div>
                                </div>
                            </form>
                           
                        </div>
                    </div>
                    <span class="sample" (click)="generateExcel()">Download Sample Document</span>
                </div>
            </div>
        </div>
    </div>
</section>